
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("kz5fq", function(module, exports) {
module.exports = JSON.parse("{\"frozen-columns-onboarding.spotlight.body\":\"Sort, freeze and resize Work from a single control.\",\"frozen-columns-onboarding.spotlight.dismiss\":\"OK\",\"frozen-columns-onboarding.spotlight.heading\":\"Manage Work\",\"jira-nin-group-by-any-field-changeboarding.spotlight.body\":\"Group work by fields including versions, labels, work types and more.\",\"jira-nin-group-by-any-field-changeboarding.spotlight.dismiss\":\"OK\",\"jira-nin-group-by-any-field-changeboarding.spotlight.heading\":\"Group work to stay organised\"}");

});


//# sourceMappingURL=en-GB.e822d894.js.map
